import { Theme } from '@mui/material'

const useStyles = {
  mainContainer: {
    rowGap: 1,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: '100px',
  },
  subtitleText: {
    marginBottom: 2,
  },
  locationContainer: {
    gap: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '32px',
  },
  placeIcon: {
    fontSize: '40px',
  },
  addressText: {
    lineHeight: '24px',
  },
  footer: (theme: Theme) => ({
    backgroundColor: theme.palette.background.default,
    boxShadow: '0px 1px 10px 0px #0000001F',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 4,
  }),
  backButton: {
    width: '120px',
  },
  continueButton: {
    width: '192px',
  },
}

export default useStyles
